// RELEASED 2026-10-02 (user's explicit approval): the Friday-call changes (SPS colour bands, info
// icons, P&L fixes) are now open to everyone. Originally gated to roland@ only -- see git history
// for the PREVIEW_EMAILS allowlist this replaced. Also covers the Marketing API (Beta) panel on
// the Paid Ads page, which reuses this same gate -- released at the same time per explicit
// instruction, despite the Ads API work itself not being fully done (no real OAuth click-through
// test has happened yet, flagged separately to Setu). The backend mirrors this same open state for
// the P&L numbers (PNL_PREVIEW_EMAILS in affiliate_creators.py), so the two must stay in sync if
// this is ever re-gated.
export function isPreviewUser(user) {
  return true;
}
